export const PayDue = {
    /** 전전월 21일 ~ 전월 20일 */
    5: 5,
    /** 전월 1일 ~ 전월 말일 */
    15: 15,
    /** 전월 11일 ~ 당월 10일 */
    25: 25,
} as const

export type PayDueType = Constant<typeof PayDue>

/** 후불결제 이용기간 */
export const PayLaterPeriod: Record<PayDueType, string> = {
    [PayDue[5]]: '전전월 21일~ 전월 20일',
    [PayDue[15]]: '전월 1일 ~ 전월 말일',
    [PayDue[25]]: '전월 11일 ~ 당월 10일',
} as const

export const PayLaterMemberStatus = {
    /** 후불결제 정보 확인 중 */
    PENDING: 'PENDING',
    /** 사용불가 */
    NOT_AVAILABLE: 'NOT_AVAILABLE',
    /** 정상 */
    NORMAL: 'NORMAL',
    /** 이용정지 */
    SUSPENDED: 'SUSPENDED',
    /** 연체 */
    OVERDUE: 'OVERDUE',
    /** 가입대상 && 미가입 */
    SIGNUP: 'SIGNUP',
    /** 후불결제 잔고 0 */
    NO_BALANCE: 'NO_BALANCE',
    /** 점검 중 */
    MAINTENANCE: 'MAINTENANCE',
    /** 보유포인트가 결제금액보다 커서 결제 대상금액이 없는 경우 */
    NO_PAYMENT: 'NO_PAYMENT',
} as const

export type PayLaterMemberStatusType = Constant<typeof PayLaterMemberStatus>

export const PayLaterSignUpStatus = {
    /** 가입 가능 */
    AVAILABLE: 'AVAILABLE',
    /**  타 아이디로 이미 가입된 상태 */
    SIGNED_UP: 'SIGNED_UP',
    /** 24시간 내 탈퇴 하여 가입 불가 상태 */
    WITHDRAWAL_LOCK: 'WITHDRAWAL_LOCK',
}

export type PayLaterSignUpStatusType = Constant<typeof PayLaterSignUpStatus>

/** 후불결제 연체 상태 */
export const PayLaterPenaltyStatus = {
    /** 연체 30일 이상 */
    NOTICED: 'NOTICED',
    /** 연체 90일 이상 */
    BLOCKED: 'BLOCKED',
} as const

export type PayLaterPenaltyStatusType = Constant<typeof PayLaterPenaltyStatus>

export const PayLaterPromotionBannerStatus = {
    SIGNUP: 'SIGNUP',
    USE: 'USE',
    NONE: 'NONE',
} as const

export type PayLaterPromotionBannerStatusType = Constant<typeof PayLaterPromotionBannerStatus>

/** 가입대상자 상태 */
export const CandidateStatus = {
    /** 후불결제 사용불가 */
    DISABLED: 'DISABLED',
    /** 가입대상자 */
    CANDIDATE: 'CANDIDATE',
    /** 가입 미대상자 */
    NOT_CANDIDATE: 'NOT_CANDIDATE',
} as const

export type CandidateStatusType = Constant<typeof CandidateStatus>
